import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ImportadorCsvService} from "../services/importador-csv.service";
import {FileRestrictions} from "@progress/kendo-angular-upload";

import {
  PainelImportacaoProdutosComponent
} from "../compartilhado/painel-importacao-produtos/painel-importacao-produtos.component";
import {ModalKendo} from "../lib/ModalKendo";
import {EstoqueService} from "../services/estoque.service";

@Component({
  selector: 'app-importador-csv',
  templateUrl: './importador-csv.component.html',
  styleUrls: ['./importador-csv.component.scss']
})
export class ImportadorCsvComponent extends ModalKendo implements OnInit, AfterViewInit {
  @ViewChild('frm', {static: true}) frm: NgForm;
  @ViewChild('painelImportacao', {static: false}) painelImportacao: PainelImportacaoProdutosComponent;
  @Input()   empresa: any = {};
  @Input()   catalogo: any = {};
  @Input()   modoInsumos = false;
  importando: boolean;
  carregando: boolean;
  mensagemSucesso: string;
  mensagemErro: string;
  importou: boolean;
  files: any = {};
  opcoes: any = {}
  tipoImportar = {
    tipo: 'Produto',
    colunas: [
      {descricao: "ID"}, {descricao: 'TipoLinha'}, {descricao: 'Referencia'}, {descricao: 'ReferenciaPai'},
      {descricao: 'Nome'}, {descricao:  'Preço'}, {descricao: 'Imagem (URL)', codigo: 'LinkImagem'},
      {descricao : 'Categoria'} , {descricao: 'Descricao'}, {descricao: 'CodigoPDV'},
      {descricao: 'TipoSelecao'}, {descricao: 'Minimo'},
      {descricao: 'Maximo'}, {descricao: 'PermiteRepetir'}, {descricao: 'TipoCobranca'},
      {descricao: 'MultiplicaQuantidadeProduto'}, {descricao: 'Disponivel'}, {descricao: 'Delivery'},
      {descricao: 'Mesa'}, {descricao: 'Ordem'}, {descricao: 'MaximoPorOpcao'},
      {descricao: 'NomeAdicional'}, {descricao: 'OpcaoAdicional'}]
  }
  colunaIgnorar = {descricao: 'Não importar', ignorar: true}
  opcoesColuna: any = []
  restricoes: FileRestrictions = {
    allowedExtensions: ['.csv'],
    maxFileSize: 10 * 1024 * 1024
  };
  arquivo: File;
  conteudoArquivo: Array<any>;
  colunasImportar: any = [];
  somentePrecos: boolean;
  separadorDecimal: any;
  separadorColunas: string;
  separadorDecimalDetectado = false;
  valorExemploPreco: number;
  larguraDaJanela: string = null;
  buscarProdutos = true;
  tudoSincronizado = false;
  exibirDetalhesAvancadosInsumos = false;
  opcoesSeparadorDecimal: any = [
    {codigo: ',', descricao: "Separado por vírgula (,)"},
    {codigo: '.', descricao: "Separado por ponto (.)"}
  ]
  constructor( private importador: ImportadorCsvService,
               private estoqueService: EstoqueService,
               private elementoHost: ElementRef) {
    super()
  }
  ngOnInit(): void {
    this.separadorDecimal = this.opcoesSeparadorDecimal[0]

    if(this.modoInsumos)
      this.configureModoInsumos()
    else if(this.somentePrecos){
      this. tipoImportar.colunas  = [
        {descricao: "ID"},  {descricao: 'CodigoPDV'}, {descricao:  'Preço'}
      ]
    }

    this.atualizeOpcoesColuna()
  }

  configureModoInsumos(): void {
    this.modoInsumos = true
    this.tipoImportar = {
      tipo: 'Insumo',
      colunas: [
        {descricao: 'Tipo de linha', codigo: 'TipoLinha'},
        {descricao: 'Referência', codigo: 'Referencia'},
        {descricao: 'Referência pai', codigo: 'ReferenciaPai'},
        {descricao: 'Referência do insumo', codigo: 'ReferenciaInsumo'},
        {descricao: 'Código', codigo: 'Codigo'},
        {descricao: 'Nome'},
        {descricao: 'Grupo'},
        {descricao: 'Unidade-base', codigo: 'UnidadeBase'},
        {descricao: 'Tipo da ficha', codigo: 'TipoFicha'},
        {descricao: 'Quantidade'},
        {descricao: 'Estoque mínimo', codigo: 'EstoqueMinimo'},
        {descricao: 'Rendimento'}
      ]
    }
    this.restricoes.maxFileSize = 5 * 1024 * 1024
    this.atualizeOpcoesColuna()
  }

  /** Coluna sem destino: fica visível, apagada e fora da importação. */
  colunaIgnorada(item: any) {
    return !item?.coluna || !!item.coluna.ignorar
  }

  ngAfterViewInit(): void {
    this.ajusteTamanhoDaJanela()
  }

  get titulo() {
    if(this.modoInsumos)
      return 'Importar insumos por CSV'
    return this.somentePrecos ? 'Atualizar preços por CSV' : 'Importar produtos por CSV'
  }

  get nomeCatalogo() {
    if(this.modoInsumos)
      return 'Estoque da loja atual'
    return this.catalogo?.nome || this.empresa?.catalogo?.nome || 'Catálogo atual'
  }

  get escolheuArquivo() {
    return !!this.conteudoArquivo?.length
  }

  /** A janela só fica larga quando existe tabela para conferir. */
  get modoCompacto() {
    return this.buscarProdutos && (!this.escolheuArquivo || this.importando || this.importou)
  }

  get colunasAceitas() {
    return this.tipoImportar.colunas
      .filter((item: any) => !this.modoInsumos ||
        this.exibirDetalhesAvancadosInsumos ||
        !this.campoTecnicoInsumos(this.obtenhaCodigoColuna(item)))
      .map((item: any) => item.descricao)
  }

  get quantidadeLinhasArquivo() {
    return Math.max((this.conteudoArquivo?.length || 0) - 1, 0)
  }

  get quantidadeColunasMapeadas() {
    return this.colunasImportar.filter((item: any) => !this.colunaIgnorada(item)).length
  }

  get camposObrigatoriosPendentes() {
    const camposMapeados = this.colunasImportar
      .filter((item: any) => !this.colunaIgnorada(item))
      .map((item: any) => this.obtenhaCodigoColuna(item.coluna))

    const obrigatorios = this.modoInsumos
      ? (this.arquivoHierarquicoInsumos
        ? [
          'TipoLinha', 'Referencia', 'ReferenciaPai', 'ReferenciaInsumo',
          'Nome', 'UnidadeBase', 'TipoFicha', 'Rendimento', 'Quantidade'
        ]
        : ['Nome', 'UnidadeBase'])
      : (this.somentePrecos ? ['CodigoPDV', 'Preço'] : ['Nome', 'Preço'])

    return obrigatorios.filter((campo: string) => !camposMapeados.includes(campo))
  }

  get podeImportar() {
    if(!this.arquivo || !this.separadorDecimal || !this.conteudoArquivo?.length)
      return false

    const camposMapeados = this.colunasImportar
      .filter((item: any) => !this.colunaIgnorada(item))
      .map((item: any) => this.obtenhaCodigoColuna(item.coluna))

    if(this.modoInsumos)
      return !this.camposObrigatoriosPendentes.length

    if(this.somentePrecos)
      return camposMapeados.includes('Preço') && camposMapeados.includes('CodigoPDV')

    return camposMapeados.includes('Preço') && camposMapeados.includes('Nome')
  }

  get arquivoHierarquicoInsumos() {
    if(!this.modoInsumos)
      return false
    const cabecalhos = this.conteudoArquivo && this.conteudoArquivo[0] || []
    return cabecalhos.some((item: string) =>
      this.obtenhaNomeColunaPorCabecalho(item) === 'TipoLinha'
    )
  }

  get visaoSimplificadaInsumos() {
    return this.modoInsumos && this.arquivoHierarquicoInsumos &&
      !this.exibirDetalhesAvancadosInsumos
  }

  get colunasImportarVisiveis() {
    if(!this.visaoSimplificadaInsumos)
      return this.colunasImportar

    return this.colunasImportar.filter((item: any) =>
      !this.campoTecnicoInsumos(this.nomeCampoDaColuna(item))
    )
  }

  get totalIngredientesArquivo() {
    if(!this.arquivoHierarquicoInsumos)
      return 0

    return (this.conteudoArquivo || [])
      .slice(1)
      .filter((linha: any) => this.linhaIngrediente(linha))
      .length
  }

  get totalCadastrosArquivo() {
    if(!this.arquivoHierarquicoInsumos)
      return this.quantidadeLinhasArquivo

    return (this.conteudoArquivo || [])
      .slice(1)
      .filter((linha: any) => Array.isArray(linha) && !this.linhaIngrediente(linha))
      .length
  }

  altereExibicaoDetalhesAvancadosInsumos(): void {
    this.exibirDetalhesAvancadosInsumos = !this.exibirDetalhesAvancadosInsumos
    this.ajusteTamanhoDaJanela()
  }

  feche() {
    this.fecheModal(this.importou)
  }

  onSubmit() {
    this.fecheMensagemErro();
    if(!this.arquivo) {
      this.mensagemErro = 'É necessário escolher um arquivo antes de iniciar a importação.'
      return;
    }

    if(!this.separadorDecimal) {
      this.mensagemErro = this.modoInsumos
        ? 'É necessário escolher o separador decimal das quantidades antes de iniciar a importação'
        : 'É necessário escolher o separador decimal do campo preço antes de iniciar a importação'
      return;
    }

    let opcoes: any = {}
    opcoes.colunas = {}

    opcoes.separadorDecimal = this.separadorDecimal
    opcoes.separadorColunas = this.separadorColunas
    let i = 0;

    let selecionouPreco = false, selecionouNome = false, selecionouCodigoPdv = false,
      selecionouUnidadeBase = false;

    for(let coluna of this.colunasImportar) {
      if(!this.colunaIgnorada(coluna)) {
        const codigoColuna = this.obtenhaCodigoColuna(coluna.coluna)
        opcoes.colunas[i] = codigoColuna

        if(codigoColuna === 'Preço')
          selecionouPreco = true;

        if(codigoColuna === 'Nome')
          selecionouNome = true;

        if(codigoColuna === 'CodigoPDV')
          selecionouCodigoPdv = true;

        if(codigoColuna === 'UnidadeBase')
          selecionouUnidadeBase = true;

      }
      i++
    }

    if(this.modoInsumos){
      if(this.camposObrigatoriosPendentes.length){
        this.mensagemErro = 'Mapeie todas as colunas obrigatórias antes de importar: ' +
          this.camposObrigatoriosPendentes.join(', ')
        return;
      }

      this.importando = true;
      this.ajusteTamanhoDaJanela();
      this.estoqueService.importeInsumosCsv(this.arquivo, opcoes).then((resposta: any) => {
        this.mensagemSucesso = "Foram importados " + resposta.insumosCriados + " insumos, " +
          (resposta.fichasCriadas || 0) + " fichas técnicas, " +
          (resposta.ingredientesCriados || 0) + " ingredientes e " +
          resposta.gruposCriados + " grupos." + (resposta.reutilizados
            ? " " + resposta.reutilizados + " cadastros existentes foram reutilizados."
            : "")
        this.importando = false;
        this.importou = true;
        this.ajusteTamanhoDaJanela();
      }).catch((erro: any) => {
        this.mensagemErro = erro;
        this.importando = false;
        this.ajusteTamanhoDaJanela();
      })
    } else if(!this.somentePrecos){
      if(!selecionouPreco || !selecionouNome) {
        this.mensagemErro = 'É necessário selecionar ao menos uma coluna para Nome e outra coluna para Preço do produto antes de importar'
        return;
      }

      this.importando = true;
      this.ajusteTamanhoDaJanela();
      this.importador.importe(this.empresa.id, this.arquivo, opcoes).then((resposta: any) => {
        console.log(resposta)
        this.mensagemSucesso = "Foram importadas " + resposta.categoriasInseridas + " categorias e " + resposta.produtosInseridos + " produtos."
        this.importando = false;
        this.importou = true;
        this.ajusteTamanhoDaJanela();

      }).catch((erro: any) => {
        console.log(erro);
        this.mensagemErro = erro;
        this.importando = false;
        this.ajusteTamanhoDaJanela();
      })
    } else {
      if(!selecionouPreco || !selecionouCodigoPdv) {
        this.mensagemErro = 'É necessário selecionar ao menos uma coluna para Codigo Pdv e outra coluna para Preço do produto antes de atualizar'
        return;
      }
      this.carregando = true;
      this.importador.obtenhaPrecosCsv(this.catalogo.id, this.arquivo, opcoes).then((resposta: any) => {
        this.carregando = false;
        this.buscarProdutos = false;
        this.ajusteTamanhoDaJanela();
        this.tudoSincronizado = !  resposta.categorias.length;

        if(!this.empresa || !this.empresa.id) this.painelImportacao.setModoRede(this.catalogo);
        this.painelImportacao.setProdutosSincronizar([], resposta.produtosAtualizar, [],
          resposta.categorias)

      }).catch((erro: any) => {
        console.log(erro);
        this.mensagemErro = erro;
        this.carregando = false;
      })
    }

  }

  fecheMensagemErro() {
    delete this.mensagemErro;
  }
  volteTela(){
    this.painelImportacao.setProdutosSincronizar([],  [], [], []);
    this.buscarProdutos = true;
    this.ajusteTamanhoDaJanela();
  }

  /** Volta para a escolha do arquivo, descartando o que já foi lido. */
  limpeArquivo() {
    this.arquivo = null
    this.files = {}
    this.conteudoArquivo = []
    this.colunasImportar = []
    this.separadorColunas = null
    this.separadorDecimalDetectado = false
    this.valorExemploPreco = null
    this.exibirDetalhesAvancadosInsumos = false
    this.fecheMensagemErro()
    this.ajusteTamanhoDaJanela()
  }

  /** A roda do mouse anda para os lados na grid; nas pontas volta a rolar a tela. */
  rodouMouseNaTabela(evento: WheelEvent) {
    const area = evento.currentTarget as HTMLElement

    if(!area || area.scrollWidth <= area.clientWidth)
      return

    const fator = evento.deltaMode === 1 ? 16 : 1
    const deslocamento = (Math.abs(evento.deltaX) > Math.abs(evento.deltaY) ? evento.deltaX : evento.deltaY) * fator

    if(!deslocamento)
      return

    const anterior = area.scrollLeft
    area.scrollLeft += deslocamento

    if(area.scrollLeft !== anterior)
      evento.preventDefault()
  }

  escolhaSeparadorDecimal(opcao: any) {
    this.separadorDecimal = opcao
    this.separadorDecimalDetectado = false
    this.fecheMensagemErro()
  }

  /** Mostra o mesmo preço do arquivo nos dois formatos, para a escolha ser visual. */
  exemploPreco(opcao: any) {
    const valorPadrao = this.modoInsumos ? 2.5 : 29.9
    const valor = this.valorExemploPreco > 0 ? this.valorExemploPreco : valorPadrao
    const texto = valor.toFixed(2)

    return opcao.codigo === ',' ? texto.replace('.', ',') : texto
  }

  /**
   * A janela encolhe na escolha do arquivo, cresce na conferência das colunas
   * e fica acima da barra fixa do painel.
   */
  private ajusteTamanhoDaJanela() {
    setTimeout(() => {
      const host: HTMLElement = this.elementoHost?.nativeElement
      const janela: HTMLElement = host?.closest('.k-dialog')

      if(!janela) return

      const moldura: HTMLElement = host?.closest('.k-dialog-wrapper')

      if(this.larguraDaJanela === null)
        this.larguraDaJanela = janela.style.width

      janela.style.height = 'auto'
      janela.style.transition = 'width 260ms cubic-bezier(0.4, 0, 0.2, 1)'
      janela.style.width = this.modoCompacto ? 'min(660px, calc(100vw - 32px))' : this.larguraDaJanela

      // A navbar do painel é fixa com z-index 100000: o modal precisa cobri-la.
      // O fundo escuro fica dentro desta moldura, então sobe junto.
      if(moldura) {
        moldura.style.zIndex = '100001'
        moldura.style.marginTop = '0'
      }
    })
  }

  parseCSV(text: string) {
    const linhas = text
      .split(/\r?\n/)       // divide em linhas
      .filter(l => l.trim()) // remove linhas vazias
    const separador = this.obtenhaSeparadorColunas(linhas[0] || '')

    return linhas
      .map(l => this.CSVtoArray(l, separador))
      .filter(linha => !!linha);
  }

  obtenhaSeparadorColunas(text: string) {
    let virgulas = 0
    let pontosEVirgulas = 0
    let dentroDeAspas = false

    for(let i = 0; i < text.length; i++) {
      if(text[i] === '"') {
        if(dentroDeAspas && text[i + 1] === '"')
          i++
        else
          dentroDeAspas = !dentroDeAspas
      } else if(!dentroDeAspas && text[i] === ',')
        virgulas++
      else if(!dentroDeAspas && text[i] === ';')
        pontosEVirgulas++
    }

    return pontosEVirgulas > virgulas ? ';' : ','
  }

  CSVtoArray(text: string, separador?: string) {
    const delimitador = separador || this.obtenhaSeparadorColunas(text)
    const colunas: string[] = []
    let valor = ''
    let dentroDeAspas = false

    for(let i = 0; i < text.length; i++) {
      const caractere = text[i]

      if(caractere === '"') {
        if(dentroDeAspas && text[i + 1] === '"') {
          valor += '"'
          i++
        } else
          dentroDeAspas = !dentroDeAspas
      } else if(caractere === delimitador && !dentroDeAspas) {
        colunas.push(valor.trim())
        valor = ''
      } else
        valor += caractere
    }

    if(dentroDeAspas)
      return null

    colunas.push(valor.trim())
    return colunas;
  };

  obtenhaCodigoColuna(coluna: any) {
    return coluna.codigo || coluna.descricao
  }

  private campoTecnicoInsumos(campo: string): boolean {
    return [
      'TipoLinha', 'Referencia', 'ReferenciaPai', 'ReferenciaInsumo', 'Quantidade'
    ].includes(campo)
  }

  private campoMapeadoAutomaticamenteInsumos(campo: string): boolean {
    return [
      'TipoLinha', 'Referencia', 'ReferenciaPai', 'ReferenciaInsumo'
    ].includes(campo)
  }

  mapeamentoAutomaticoInsumos(item: any): boolean {
    return this.modoInsumos &&
      this.campoMapeadoAutomaticamenteInsumos(this.nomeCampoDaColuna(item))
  }

  private atualizeOpcoesColuna(): void {
    const colunas = this.modoInsumos
      ? this.tipoImportar.colunas.filter((item: any) =>
        !this.campoMapeadoAutomaticamenteInsumos(this.obtenhaCodigoColuna(item))
      )
      : this.tipoImportar.colunas
    this.opcoesColuna = [this.colunaIgnorar, ...colunas]
  }

  private nomeCampoDaColuna(item: any): string {
    if(item && item.coluna)
      return this.obtenhaCodigoColuna(item.coluna)

    const cabecalho = this.conteudoArquivo && this.conteudoArquivo[0]
      ? this.conteudoArquivo[0][item.indice]
      : null
    return this.obtenhaNomeColunaPorCabecalho(cabecalho)
  }

  private indiceColuna(campo: string): number {
    const coluna = this.colunasImportar.find((item: any) =>
      this.nomeCampoDaColuna(item) === campo
    )
    return coluna ? coluna.indice : -1
  }

  private linhaIngrediente(linha: any): boolean {
    if(!Array.isArray(linha))
      return false

    const indice = this.indiceColuna('TipoLinha')
    return indice >= 0 && String(linha[indice] || '').trim().toUpperCase() === 'INGREDIENTE'
  }

  valorPrevia(linha: any[], item: any): string {
    const valor = linha && linha[item.indice]
    if(this.visaoSimplificadaInsumos && this.nomeCampoDaColuna(item) === 'TipoFicha'){
      if(valor === 'produto-beneficiado')
        return 'Ficha beneficiada'
      if(valor === 'produto-venda')
        return 'Ficha de produto'
    }
    return valor
  }

  obtenhaColuna(nome: string){
    return this.tipoImportar.colunas.find((item: any) => this.obtenhaCodigoColuna(item) === nome)
  }

  obtenhaNomeColunaPorCabecalho(cabecalho: string) {
    const normalizado = String(cabecalho || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase();
    const aliasesInsumo: any = {
      CODIGO: 'Codigo',
      NOME: 'Nome',
      GRUPO: 'Grupo',
      UNIDADE: 'UnidadeBase',
      UNIDADEBASE: 'UnidadeBase',
      UNIDADEMEDIDA: 'UnidadeBase',
      UNIDADEDEMEDIDA: 'UnidadeBase',
      ESTOQUEMINIMO: 'EstoqueMinimo',
      QUANTIDADEMINIMA: 'EstoqueMinimo',
      MINIMO: 'EstoqueMinimo',
      TIPOLINHA: 'TipoLinha',
      REFERENCIA: 'Referencia',
      REFERENCIAPAI: 'ReferenciaPai',
      REFERENCIAINSUMO: 'ReferenciaInsumo',
      TIPOFICHA: 'TipoFicha',
      RENDIMENTO: 'Rendimento',
      QUANTIDADE: 'Quantidade'
    };
    if(this.modoInsumos)
      return aliasesInsumo[normalizado];

    const aliases: any = {
      ID: 'ID',
      TIPOLINHA: 'TipoLinha',
      REFERENCIA: 'Referencia',
      REFERENCIAPAI: 'ReferenciaPai',
      PRODUTO: 'Nome',
      NOME: 'Nome',
      PRECO: 'Preço',
      CATEGORIA: 'Categoria',
      DESCRICAO: 'Descricao',
      CODPDV: 'CodigoPDV',
      CODIGOPDV: 'CodigoPDV',
      IMAGEM: 'LinkImagem',
      IMAGEM1: 'LinkImagem',
      IMAGEMURL: 'LinkImagem',
      LINKIMAGEM: 'LinkImagem',
      LINKDAIMAGEM: 'LinkImagem',
      URLIMAGEM: 'LinkImagem',
      URLIMAGEM1: 'LinkImagem',
      URLDAIMAGEM: 'LinkImagem',
      TIPOSELECAO: 'TipoSelecao',
      MINIMO: 'Minimo',
      MAXIMO: 'Maximo',
      PERMITEREPETIR: 'PermiteRepetir',
      TIPOCOBRANCA: 'TipoCobranca',
      MULTIPLICAQUANTIDADEPRODUTO: 'MultiplicaQuantidadeProduto',
      DISPONIVEL: 'Disponivel',
      DELIVERY: 'Delivery',
      MESA: 'Mesa',
      ORDEM: 'Ordem',
      MAXIMOPOROPCAO: 'MaximoPorOpcao',
      NOMEADICIONAL: 'NomeAdicional',
      OPCAOADICIONAL: 'OpcaoAdicional'
    };

    return aliases[normalizado];
  }

  /**
   * Descobre o separador decimal olhando os valores de preço do arquivo.
   * Retorna ',' , '.' ou null quando o arquivo não deixa claro.
   */
  detecteSeparadorDecimal(linhas: Array<any>) {
    if(!linhas?.length)
      return null

    const cabecalho = linhas[0] || []
    const camposDecimais = this.modoInsumos
      ? ['EstoqueMinimo', 'Rendimento', 'Quantidade']
      : ['Preço']
    const indicesPreco = cabecalho
      .map((titulo: string, indice: number) => camposDecimais.includes(
        this.obtenhaNomeColunaPorCabecalho(titulo)
      ) ? indice : -1)
      .filter((indice: number) => indice >= 0)

    let virgulas = 0, pontos = 0
    let exemplo: any = null

    for(const linha of linhas.slice(1, 201)) {
      if(!Array.isArray(linha)) continue

      const valores = indicesPreco.length ? indicesPreco.map((indice: number) => linha[indice]) : linha

      for(const valor of valores) {
        const separador = this.obtenhaSeparadorDecimalDoValor(valor)

        if(!separador) continue

        if(separador === ',') virgulas++
        else pontos++

        if(!exemplo) exemplo = {valor, separador}
      }
    }

    if(!virgulas && !pontos)
      return null

    const separador = virgulas >= pontos ? ',' : '.'

    if(exemplo?.separador === separador)
      this.valorExemploPreco = this.converteEmNumero(exemplo.valor, separador)

    return separador
  }

  private obtenhaSeparadorDecimalDoValor(valor: any) {
    const texto = String(valor ?? '').trim().replace(/^R\$\s*/i, '')

    if(!/^-?\d{1,3}([.,]\d{3})*([.,]\d{1,2})?$/.test(texto))
      return null

    const decimal = texto.match(/([.,])\d{1,2}$/)

    return decimal ? decimal[1] : null
  }

  private converteEmNumero(valor: any, separadorDecimal: string) {
    const separadorMilhar = separadorDecimal === ',' ? '.' : ','
    const texto = String(valor ?? '')
      .trim()
      .replace(/^R\$\s*/i, '')
      .split(separadorMilhar).join('')
      .replace(separadorDecimal, '.')

    const numero = Number(texto)

    return isNaN(numero) ? null : numero
  }

  private apliqueSeparadorDecimalDetectado() {
    this.valorExemploPreco = null
    const detectado = this.detecteSeparadorDecimal(this.conteudoArquivo)

    this.separadorDecimalDetectado = !!detectado

    if(detectado)
      this.separadorDecimal = this.opcoesSeparadorDecimal
        .find((opcao: any) => opcao.codigo === detectado)
  }

  selecionouArquivo(e: any) {
    const arquivoSelecionado = e.files && e.files[0]

    if(!arquivoSelecionado || arquivoSelecionado.validationErrors?.length) {
      this.arquivo = null
      this.conteudoArquivo = []
      this.separadorColunas = null
      this.mensagemErro = this.modoInsumos
        ? 'Selecione um arquivo CSV válido com no máximo 5MB.'
        : 'Selecione um arquivo CSV válido com no máximo 10MB.'
      return
    }

    this.arquivo = arquivoSelecionado.rawFile;
    this.exibirDetalhesAvancadosInsumos = false
    this.conteudoArquivo = []
    this.separadorColunas = null
    let reader = new FileReader();
    reader.readAsText(this.arquivo, "UTF-8");
    reader.onload =  (evt) => {
      let conteudo: any =  evt.target.result ;

      let linhas = conteudo.match(/[^\r\n]+/g) || []
      const separadorColunas = this.obtenhaSeparadorColunas(linhas[0] || '')
      this.separadorColunas = separadorColunas

      for(let linha of linhas) {
        let colunas =  this.CSVtoArray(linha, separadorColunas)

        /*
        let objeto: any = {}

        for(let i = 0; i < colunas.length; i++)
          objeto[i] = colunas[i]*/

        if(colunas)
          this.conteudoArquivo.push(colunas);
      }

      if(!this.conteudoArquivo.length) {
        this.mensagemErro = 'Não foi possível identificar linhas válidas no arquivo CSV.'
        return
      }

      this.apliqueSeparadorDecimalDetectado();

      let i = 0;
      this.colunasImportar = []; // Limpa colunas anteriores
      if(this.conteudoArquivo.length > 0)
        this.conteudoArquivo[0].forEach( (item: string) => {
          let coluna: any = {
            indice: i,
            coluna: null
          };
          const nomeColuna = this.obtenhaNomeColunaPorCabecalho(item);

          if(nomeColuna)
            coluna.coluna = this.obtenhaColuna(nomeColuna);

          this.colunasImportar.push( coluna )
          i++
        })

      this.fecheMensagemErro();
      this.ajusteTamanhoDaJanela();
    }
    reader.onerror = (evt) => {
      this.mensagemErro = "Houve um erro ao ler o arquivo."
    }


  }

  primeirasLinhas(){
    return (this.conteudoArquivo || [])
      .filter((linha: any) => Array.isArray(linha))
      .filter((linha: any, indice: number) => indice > 0)
      .filter((linha: any) => !this.visaoSimplificadaInsumos || !this.linhaIngrediente(linha))
      .slice(0, 10)
  }
}
